export const get = {
    method: 'GET',
    paths: ['/api/orgs/:orgId/locationId/:locationId/status'],
    fields: {
        before: {
            type: 'timestamp',
            required: true,
        },
        after: {
            type: 'timestamp',
            required: true,
        },
    },
};
//# sourceMappingURL=status_get.js.map